export const CHANGE_SIGNALR_CONNECTION_STATE = 'CHANGE_SIGNALR_CONNECTION_STATE'